import { useCallback } from 'react'

import dayjs from 'dayjs'
import { Select } from 'govwell-ui'
import { SelectOption } from 'govwell-ui/components/Select/types'

import { DateFormats } from 'src/utils/date'

const options: SelectOption<number>[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((month) => ({
  label: dayjs()
    .month(month - 1)
    .format(DateFormats.Month),
  value: month,
}))

type Props = {
  isDisabled?: boolean
  onValueChange: (value: number | undefined) => void
  value: number | undefined
}
const MonthSelect = ({ value, onValueChange, isDisabled }: Props) => {
  const handleSelectedOptionChange = useCallback(
    (option: SelectOption<number> | undefined) => {
      onValueChange(option?.value)
    },
    [onValueChange]
  )

  return (
    <Select
      ariaLabel="Month"
      getOptionKey={(o) => o.value}
      onSelectedOptionChange={handleSelectedOptionChange}
      options={options}
      selectedOption={options.find((o) => o.value === value)}
      width="120px"
      placeholder="Month"
      isDisabled={isDisabled}
    />
  )
}

export default React.memo(MonthSelect)
